import * as React from 'react';

export const withDefaultProps =
  <P extends Record<string, unknown>, D extends P>(WrappedComponent: React.FC<P>, defaultProps: D) =>
  (props: P) => {
    const propsWithDefaults = {
      ...defaultProps,
      ...props,
    };

    return <WrappedComponent {...propsWithDefaults} />;
  };
